module.exports = __webpack_public_path__ + "static/media/c1905e2e-a1cb-49de-9bb0-ce3c5ffc85ae.6039d7ca.woff2";